import React from 'react';
import { Button } from '@mui/material';
import { EVENT_APPRAISER_ASSIGNMENT_STATUS } from '../../../shared/constants/eventAppraiserAssignmentStatus';

/**
 * @typedef {object} AssignmentButtonsProps
 * @property {string} [acceptLabel]
 * @property {string} [rejectLabel]
 * @property {(status: number) => void} onAction
 */

/**
 * @param {AssignmentButtonsProps} props
 */
const AssignmentButtons = props => {
  const { acceptLabel = 'Accept', rejectLabel = 'Reject', onAction } = props;

  return (
    <>
      <Button
        type='button'
        className='primary-button sm'
        onClick={() => onAction(EVENT_APPRAISER_ASSIGNMENT_STATUS.ACCEPTED)}>
        {acceptLabel}
      </Button>

      <Button
        type='button'
        className='delete-button sm'
        onClick={() => onAction(EVENT_APPRAISER_ASSIGNMENT_STATUS.REJECTED)}>
        {rejectLabel}
      </Button>
    </>
  );
};

export default AssignmentButtons;
